import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import markdownit from 'markdown-it';
import 'github-markdown-css/github-markdown-light.css';
import axios from 'axios';
import { BContainer,BButton,BRow,BCol } from "bootstrap-vue-next";
import HeaderBar from '@/components/HeaderBar.vue';

export default {
  name: 'TermsOfService',
  components: {
    Loading,BContainer,BButton,BRow,BCol,HeaderBar
  },

  // 共通関数
  //mixins: [netutils],

  // ローカルデータ変数
  data() {
    return {
      // メッセージ
      message: {
        is_alert: false,
        variant: "",
        message: "",
      },
      // ローディング
      loader: {
        is_loading: false,
        is_full_page: true,
      },
      // バインドデータ
      bind_data: {
        markdownit: null, //マークダウンオブジェクト
        markdowntext: "", //HTML化したテキスト
      },
      // ローカルデータ
      local_data: {
        markdowntext: "",
      },
      // 状態データ
      state_data: {
        is_header_footer: true
      }
    }
  },

  // 既定計算
  computed: {
    currentLocale() {
      return this.$i18n ? this.$i18n.locale : 'ja';
    }
  },

  watch: {
    currentLocale() {
      this.loadMarkdown();
    }
  },

  // インスタンス初期化後
  created: function(){
    this.bind_data.markdownit = new markdownit();
  },
  // インスタンス破棄後
  destroyed: function() {
  },
  // インスタンスマウント後
  mounted: async function(){
    let href = window.location.href;
    console.log("TermsOfService:href="+href);
    let url = window.location.search;
    console.log("TermsOfService:url="+url);
    let params = new URLSearchParams(url);
    console.log("TermsOfService:"+params);
    if( params == "from=skill" ){
      this.state_data.is_header_footer = false;
    }

    await this.loadMarkdown();
  },

  // ローカル関数
  methods: {
    async loadMarkdown() {
      this.loader.is_loading = true;
      try {
        const lang = this.currentLocale === 'en' ? 'en' : 'ja';
        const res = await axios.get(`/terms_of_service_${lang}.md`);
        this.bind_data.markdowntext = this.bind_data.markdownit.render(res.data);
      } catch (e) {
        console.error("Failed to load markdown:", e);
      } finally {
        this.loader.is_loading = false;
      }
    },
    home(){
      // 画面遷移
      this.$router.push({ path:'/Home' });
    },
    Guide(){
      // 画面遷移
      this.$router.push({ path:'/Guide' });
    },
    privacy_policy(){
      // 画面遷移
      this.$router.push({ path:'/PrivacyPolicy' });
    },
    terms_of_service(){
      // 画面遷移
      this.$router.push({ path:'/TermsOfService' });
    },
  }
}
